module.exports = __webpack_public_path__ + "static/media/ClaimESF.ee25d3a2.png";